// extracted by mini-css-extract-plugin
module.exports = {"root":"BranchSelector_root__1nSdS","select":"BranchSelector_select__3rLsB"};